import Vue from 'vue'
import VueRouter from 'vue-router'
import { logUserAction } from '../utils/logging'

import ThankYouPage from '../views/thankyou.vue'
import InterstitialPage from '../views/interstitial.vue'
import TermsPage from '../views/terms.vue'
import PreLoginAd from '../views/pre-login-ad.vue'
import ConsentForm from '../views/ConsentForm.vue'
import Covid from '../views/covid.vue'
import PaymentPlans from '../views/PaymentPlans.vue'
import Logins from '../views/logins.vue'
import store from '../store.js'
import ContractFailed from '../views/outdatedContract'
import RetryConnection from '../views/retryConnection.vue'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'TermsPage',
    component: TermsPage,
  },
  {
    path: '/pre-login-ad',
    name: 'PreLoginAd',
    component: PreLoginAd,
    beforeEnter: (to, from, next) => {
      const flags = store.state.baseData.flags || {}
      const adConfig = store.state.baseData.advertisement?.preLogin || {}

      if (flags.isAdvertising && flags.adsPreLogin && adConfig.integrationId) {
        next()
      } else {
        if (flags.isConsent) {
          next('/consent')
        } else if (flags.isCovid) {
          next('/covid')
        } else if (flags.isPaidCampaign) {
          next('/payment-plans')
        } else {
          next('/social-logins')
        }
      }
    },
  },
  {
    path: '/thankyou',
    name: 'thankyou',
    component: ThankYouPage,
  },
  {
    path: '/interstitial',
    name: 'interstitial',
    component: InterstitialPage,
  },
  {
    path: '/consent',
    name: 'ConsentForm',
    component: ConsentForm,
    beforeEnter: (to, from, next) => {
      if (store.state.baseData.flags && store.state.baseData.flags.isConsent) {
        next(true)
      } else {
        next('/covid')
      }
    },
  },
  {
    path: '/covid',
    name: 'Covid',
    component: Covid,
    beforeEnter: (to, from, next) => {
      if (store.state.baseData.flags && store.state.baseData.flags.isCovid) {
        next(true)
      } else {
        next('/payment-plans')
      }
    },
  },
  {
    path: '/payment-plans',
    name: 'PaymentPlans',
    component: PaymentPlans,
  },
  {
    path: '/social-logins',
    name: 'Logins',
    component: Logins,
  },
  {
    path: '/contract-failed',
    name: 'ContractFailed',
    component: ContractFailed,
  },
  {
    path: '/retry-connection',
    name: 'RetryConnection',
    component: RetryConnection,
  },
  {
    path: '*',
    redirect: '/',
  },
]
const router = new VueRouter({
  routes,
})

router.beforeEach((to, from, next) => {
  logUserAction({ type: 'navigation', from: from.fullPath, to: to.fullPath })
  next()
})

export default router
